<template>
	<EMCoreTemplate category="Core" identity="user" entity="core_user"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		name: 'User',
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementCore/containers/User.vue